var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.685 16a1 1 0 0 1-.6-.205 1.085 1.085 0 0 1-.38-1.135l1.16-4.5-3.5-2.945A1.095 1.095 0 0 1 .05 6.03a1 1 0 0 1 .915-.735l4.5-.24L7.065.68a1 1 0 0 1 1.895 0l1.61 4.375 4.5.24a1.035 1.035 0 0 1 .915.735 1.095 1.095 0 0 1-.33 1.16l-3.5 2.94 1.165 4.5a1.085 1.085 0 0 1-.385 1.135 1 1 0 0 1-1.15.035L8 13.265l-3.76 2.56a1 1 0 0 1-.555.175Z",
    clipRule: "evenodd"
  })));
};
export default SvgStarFilled;